import xss from 'xss';

export const attemptedScript = function (str) {
  let r = false;
  if (str.toLowerCase().indexOf('script') > 0) {
    // STEP: Create the regexp...note the escaped '\' which is necessary cause we are passing a string
    r = new RegExp('(<|&lt;|&#60;|%3C)\\s*script', 'gi').test(str);
  }
  return r;
};

export const sanitize = (dirty, options = {}) => xss(dirty, options);

export default sanitize;
